module.exports = __webpack_public_path__ + "images/logo_kakaxi.png?v=9a90f03b0c0da0b7cd16877cc56ba3fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo_kakaxi.png
// module id = 622
// module chunks = 0